import Radium from '@flipdish/radium';
import * as React from 'react';
import { Link } from 'react-router';
import * as Api from '../../Api';
import GoogleMap from '../GoogleMap';
const tinycolor = require('tinycolor2');

interface Props {
  DeliveryLocation: Api.DeliveryLocation | null;
  type: 'collection' | 'delivery';
  AppDesignScheme: Api.AppDesignScheme;
  isDark: boolean;
}

interface State {}

class DeliveryMap extends React.Component<Props, State> {
  public showMap = (): boolean => {
    return this.props.type === 'delivery';
  };

  public render(): JSX.Element | null {
    let map: JSX.Element | null = null;

    if (this.showMap()) {
      const { DeliveryLocation } = this.props;

      if (DeliveryLocation) {
        map = (
          <GoogleMap
            apiKey="AIzaSyDPmaK_ZeZzYITQHT9KpftobsXIz3r8SWo"
            center={[
              DeliveryLocation.Coordinates.Latitude,
              DeliveryLocation.Coordinates.Longitude
            ]}
            width={328}
            height={128}
            zoom={17}
            scale={2}
            markers={[
              [
                DeliveryLocation.Coordinates.Latitude,
                DeliveryLocation.Coordinates.Longitude
              ]
            ]}
            stretch={true}
          />
        );
      }
    }

    if (map === null) {
      return null;
    }

    const { AppDesignScheme, isDark } = this.props;

    const styles = {
      map: {
        borderColor: tinycolor(AppDesignScheme.Primary)
          .darken(20)
          .toString(),
        boxShadow: `1px 1px 9px -5px ${AppDesignScheme.Secondary}`,
        WebkitBoxShadow: `1px 1px 9px -5px ${AppDesignScheme.Secondary}`
      },
      darkMap: {
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString(),
        boxShadow: `1px 1px 9px -5px ${tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString()}`,
        WebkitBoxShadow: `1px 1px 9px -5px ${tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString()}`
      }
    };

    return (
      <Link to="/where" aria-hidden="true">
        <div
          className="menu__map hidden-sm hidden-xs"
          style={isDark ? styles.darkMap : styles.map}
        >
          {map}
        </div>
      </Link>
    );
  }
}

export default Radium(DeliveryMap);
